import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CategoriesService } from '../services/categories.service';

export function uniqueValueValidator(
  fieldType: 'name' | 'url',
  categoriesService: CategoriesService,
  currentCategoryId?: number,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').trim().toLowerCase();
    if (!value) return null;

    const categories = categoriesService.categories();

    const isNotUnique = categories.some(
      (category) =>
        (category[fieldType] || '').trim().toLowerCase() === value &&
        category.id !== currentCategoryId,
    );

    return isNotUnique ? { notUnique: true } : null;
  };
}
